import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
  disable: 'phone', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function

  once: true, // whether animation should happen only once - while scrolling down
})
